import React from 'react';

import { ColorPicker, UNSET, ValueBoxGroupOptions } from '@candu-ai/craft/ui';
import { getCssResetStyleMessage, StyleHierarchy, StylesHierarchy } from 'craft/hooks';
import { createToggle } from 'craft/utils';

interface Props {
  cssProps: Record<string, unknown>;
  setCss: (e: Record<string, unknown>) => void;
  stylesHierarchy: StylesHierarchy;
  label: string;
  isInGroup?: ValueBoxGroupOptions;
}

export const TextColor = ({ cssProps, setCss, label, isInGroup, stylesHierarchy }: Props) => {
  const toggleValues = createToggle(cssProps, setCss);

  const defaultValue = stylesHierarchy?.color?.fallbackValue || UNSET;

  return (
    <ColorPicker
      isInGroup={isInGroup}
      label={label}
      value={cssProps.color || defaultValue}
      onResetTooltip={getCssResetStyleMessage(StyleHierarchy.Styleguide) || ''}
      defaultValue={defaultValue as string}
      onChange={(newColor: string) => toggleValues({ color: newColor })}
    />
  );
};
